module.exports = __webpack_public_path__ + "static/media/arrows-alt.d1f67c62.svg";